const statusOptions = [
  {value: null, label: 'All'},
  {value: 'SUCCESS', label: 'Success'},
  {value: 'UNCLAIMED', label: 'Unclaimed'},
  {value: 'FAILED', label: 'Failed'},
  {value: 'ERROR', label: 'Error'},
];

export default statusOptions;
